import { createSelector } from '@ngrx/store';

import { createEntityCollectionStore } from '@core/ngrx-legacy';
import type { IsoCurrency } from '@core/payments-types';

const { actions, selectors, reducer, namespace } = createEntityCollectionStore<IsoCurrency>()(
  'Currency',
  {
    idSelector: entity => entity.code,
  },
);

const CurrencySelectors = {
  ...selectors,
  currenciesMap: createSelector(selectors.entities(), currencies =>
    currencies.reduce(
      (acc, currency) => {
        acc[currency.code] = currency.name;
        return acc;
      },
      <Record<string, string>>{},
    ),
  ),
};

export {
  actions as CurrencyActions,
  CurrencySelectors,
  reducer as CurrencyReducer,
  namespace as CurrencyNamespace,
};
